import React from 'react';
import { InvoiceStatus as Status } from 'types/invoice';

interface Props {
  status: Status;
}

const InvoiceStatus: React.FC<Props> = ({ status }) => {
  if (status === Status.Void) {
    return <span>Void</span>;
  }
  if (status === Status.SentToCustomer) {
    return <span>Sent to customer</span>;
  }
  if (status === Status.Paid) {
    return <span>Paid</span>;
  }
  if (status === Status.Draft) {
    return <span>Draft</span>;
  }

  return <span>Local draft</span>;
};

export default InvoiceStatus;
